var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3337 1.66675H6.66699C3.33366 1.66675 1.66699 3.33341 1.66699 6.66675V17.5001C1.66699 17.9584 2.04199 18.3334 2.50033 18.3334H13.3337C16.667 18.3334 18.3337 16.6667 18.3337 13.3334V6.66675C18.3337 3.33341 16.667 1.66675 13.3337 1.66675ZM11.667 12.7084H5.83366C5.49199 12.7084 5.20866 12.4251 5.20866 12.0834C5.20866 11.7417 5.49199 11.4584 5.83366 11.4584H11.667C12.0087 11.4584 12.292 11.7417 12.292 12.0834C12.292 12.4251 12.0087 12.7084 11.667 12.7084ZM14.167 8.54175H5.83366C5.49199 8.54175 5.20866 8.25842 5.20866 7.91675C5.20866 7.57508 5.49199 7.29175 5.83366 7.29175H14.167C14.5087 7.29175 14.792 7.57508 14.792 7.91675C14.792 8.25842 14.5087 8.54175 14.167 8.54175Z",
    fill: "#444656"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.30108e6160efde2b9c6d2a07055d743c.svg";
export { ForwardRef as ReactComponent };